<template>
    <div class="grid gap-2">
        <div class="flex items-center gap-3">
            <DsAvatarInitials
                :firstName="client.first"
                :lastName="client.last"
                size="md"
            />
            <div class="flex flex-1 flex-col gap-1">
                <p class="text-content-lg text-content-primary">
                    <span class="font-semibold capitalize">{{ client.role }}</span>
                    {{ client.first }} {{ client.last }}
                </p>
                <div class="flex items-center gap-2">
                    <span class="flex items-center gap-1">
                        <DsIcon
                            icon="fa-regular fa-envelope"
                            size="sm"
                        />
                        <span class="whitespace-nowrap text-content-sm text-content-primary">
                            {{ client.email }}
                        </span>
                    </span>
                    <span class="flex items-center gap-1">
                        <DsIcon
                            icon="fa-regular fa-phone"
                            size="sm"
                        />
                        <span class="whitespace-nowrap text-content-sm text-content-primary">
                            {{ client.phone }}
                        </span>
                    </span>
                </div>
            </div>
        </div>

        <div class="grid gap-4 rounded-lg bg-ds-gray-50 p-3">
            <div>
                <p class="mb-2 text-content-md font-medium text-content-primary">Assigned tasks</p>
                <div class="grid grid-cols-2 gap-y-2 text-content-md">
                    <DsCheckbox
                        disabled
                        label="Request wire instructions"
                        :model-value="client.tasks.requestWireInstructions"
                        :name="`wire-${client.email}`"
                        value="request-wire-instructions"
                    />
                    <DsCheckbox
                        disabled
                        label="Request identity verification"
                        :model-value="client.tasks.requestIdentityVerification"
                        :name="`idv-${client.email}`"
                        value="request-identity-verification"
                    />
                </div>
            </div>

            <div v-if="client.wireInstructionsDocumentName">
                <p class="mb-2 text-content-md font-medium text-content-primary">Wire instructions</p>
                <div class="flex items-center gap-2 rounded-lg border border-ds-gray-200 bg-white p-3">
                    <DsIcon
                        icon="fa-regular fa-file-invoice-dollar"
                        size="md"
                    />
                    <p class="text-content-md text-content-primary">
                        {{ client.wireInstructionsDocumentName }}
                    </p>
                </div>
            </div>

            <div v-if="client.documents.length">
                <p class="mb-2 text-content-md font-medium text-content-primary">Documents being sent</p>
                <div class="grid gap-2">
                    <div
                        v-for="document in client.documents"
                        :key="document.name"
                        class="flex items-center justify-between gap-4 rounded-lg border border-ds-gray-200 bg-white p-3"
                    >
                        <div class="flex items-center gap-2">
                            <DsIcon
                                icon="fa-regular fa-file-lines"
                                size="md"
                            />
                            <p class="text-content-md text-content-primary">{{ document.name }}</p>
                        </div>
                        <DsTag
                            v-if="document.needsEsign"
                            text="Needs signature"
                            variant="warning"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsAvatarInitials from '@/components/design-system/avatar/DsAvatarInitials.vue';
import DsCheckbox from '@/components/design-system/form/input/DsCheckbox.vue';
import DsTag from '@/components/design-system/tag/DsTag.vue';
import type { AddFileConfirmationClient } from '@/components/Views/Company/File/file.types';

defineProps<{
    client: AddFileConfirmationClient;
}>();
</script>
